export default class Rectangle {
  constructor(x, y, width, height) {
    this.x1 = x
    this.y1 = y
    this.x2 = x + width
    this.y2 = y + height
  }

  get x() {
    return this.x1
  }

  set x(value) {
    const diff = value - this.x1
    this.x1 += diff
    this.x2 += diff
  }

  get y() {
    return this.y1
  }

  set y(value) {
    const diff = value - this.y1
    this.y1 += diff
    this.y2 += diff
  }

  get width() {
    return this.x2 - this.x1
  }

  get height() {
    return this.y2 - this.y1
  }

  enlarge(rectangle) {
    if (rectangle.x1 < this.x1) {
      this.x1 = rectangle.x1
    }
    if (rectangle.x2 > this.x2) {
      this.x2 = rectangle.x2
    }
    if (rectangle.y1 < this.y1) {
      this.y1 = rectangle.y1
    }
    if (rectangle.y2 > this.y2) {
      this.y2 = rectangle.y2
    }
  }
}
